/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Memory_Tool_Saved_PersonalInputs */



/**
* | output |
* | --- |
* | "Remembered about you" |
*
* @param {Memory_Tool_Saved_PersonalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const memory_tool_saved_personal = /** @type {((inputs?: Memory_Tool_Saved_PersonalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Memory_Tool_Saved_PersonalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Über dich gemerkt")
	return /** @type {LocalizedString} */ ("Remembered about you")
});